<template>
  <div class="guest-a" :class="{double: data.items.length <= 2, single: data.items.length == 1}">
    <template v-for="(item, i) in data.items">
      <div class="item" :key="`${item.sort}-${i}`">
        <div class="item-top">
          <div class="img-head">
            <div class="img" :style="{'background-image': `url(${item.content.avatar.url ||item.content.avatar})`}"></div>
          </div>
          <div class="person-msg">
            <div class="name">{{item.content.name}}</div>
            <div class="title">{{item.content.title}}</div>
          </div>
        </div>
        <!-- <div class="desc" v-if="item.desc">{{item.desc}}</div> -->
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'e-guest-a',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/common';

.guest-a {
  display: flex;
  flex-wrap: wrap;

  &.double {
    justify-content: center;
  }

  & .item {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 28px;
    width: 200px;
    word-break: break-all;
    &:nth-child(3n-1) {
      margin: 0 50px;
    }
    & .item-top {
      display: flex;
      flex-direction: column;
      align-items: center;

      & .person-msg {
        text-align: center;

        & .name {
          padding-top: 12px;
          margin-bottom: 4px;
          @include lineFont(16, 600);
          color: $lightBlack;
        }

        & .title {
          line-height: 21px;
          color: $gray;
          @include font(14, 400);
        }
      }

      & .img-head {
        flex: none;
        width: 79px; height: 79px;
        background: #fff;
        border: 1px solid $blue;
        border-radius: 50%;

        & .img {
          width: 100%; height: 100%;
          background-size: cover;
          background-position: center center;
          box-sizing: border-box;
          border: 3px solid #fff;
          border-radius: 50%;
        }
      }
    }

    & .desc {
      padding-top: 16px;
      text-align: justify;
      line-height: 24px;
      @include font(16, 400);
      color: $lightBlack;
    }
  }
}

@media screen and (max-width: 768px) {
  .guest-a {
    padding: 0 20px;
    justify-content: space-between;
    &.double {
      justify-content: space-between;
    }

    &.single {
      justify-content: center;
      & .item:first-child {
        margin-right: 0;
      }
    }

    & .item {
      width: 45%;
      &:nth-child(3n-1) {
        margin: 0;
      }
    }
  }
}
</style>
